import accordDefault from "./sub/urDataGridContentAccordionDefault.vue";

/* XXX 애니메이셔어어어어어어어어어어언!!!!! 넣고싶다. */

export default {
    name : 'urDataGridContentAccordionRow',
    inject : ['gridInfo'],
    props: {
        row      : {type:Object},
        vertical : {type:Boolean}
    },
    beforeDestroy() {
        this.gridInfo.func.groupTreeOffset();
    },
    render(h) {
        // 1. Check sub contents
        var subContent = [];
        if(this.gridInfo.slot['accordion']) {
            subContent = this.gridInfo.slot['accordion']({row:this.row});
            if(!subContent) return null;
        } else {
            subContent = [h(accordDefault,{'props':{'row':this.row}})]
        }
        // 2. Make accordion wrapper
        // 2.1 check vertical
        var opts = {}
        if(this.vertical) {
            opts.staticClass = "ur-data-grid__content__accordion-vert";
            subContent.push(h('div',{staticClass:'ur-data-grid__content__accordion-vert__close'},[
                h("ur-icon",{on:{click:()=>{
                    this.gridInfo.func.openAccordion(this.row, false)
                }}},['close'])
            ]))
            // ---------------
            var vertWidth = this.gridInfo.opts.accordionVertical || this.gridInfo.vars_freezeWidth
            opts.style = {'left':`${vertWidth}px`}
            
            
        } else {
            opts.staticClass = "ur-data-grid__content__accordion-row";
            
        }
        var ref = h('div',opts, subContent);
        this.$nextTick(()=>{
            var el = ref.elm;
            if(!el) return;
            var accHait = el.getBoundingClientRect().height;
            this.gridInfo.func.setRowValue(this.row, '__accordionHeight', accHait)
            this.gridInfo.func.groupTreeOffset();
        })
        return ref;
    }
}
